import { CustomerGroupType } from '../groups';

export interface BulkUploadRequest {
  entity: string;
  records: any;
  companyCode: string;
  fileName: string;
  workspaceId: string;
}

export interface BulkImportDataRequest {
  uploadBatchId: string;
  params: {
    entity: string;
    pageNo: number;
    pageSize: number;
    searchKey?: string;
    uploadStatus?: string;
  };
  body?: {
    in?: {
      customerFirmName?: string[];
      mapping_status?: string[];
      upload_status?: string[];
      transactionType?: string[];
    };
    date?: {
      transactionDate?: TransactionDate;
      dueDate?: TransactionDate;
    };
  };
}

interface TransactionDate {
  startDate: string;
  endDate: string;
}

export interface BulkImportDataResponse {
  records: BulkImportDataRecord[];
  mappingStatusAndCounts?: {
    EXISTING: number;
    MAPPING_FOUND: number;
    MAPPED_PARTIALLY: number;
    MAPPING_NOT_FOUND: number;
    null: number;
  };
  id: string;
  createdAt: string;
  updatedAt: string;
  totalRecords: number;
  processedRecords: number;
  notProcessedRecords: number;
  failedRecords: number;
  successfulRecords: number;
  status: BulkImportStatus;
  entity: string;
  companyCode: string;
  workspaceId: string;
  reprocessCount: number;
  fileName: string;
  parentUploadBatches: any;
  erpSyncBatchId: string;
  startRecord: number;
  endRecord: number;

  mapping_status?: BulkRecordMappingStatus[];
  upload_status?: string[];
  customerFirmName?: string[];
  transactionType?: string[];
  dateFilter?: string[];
}

export interface BeatPlanSchedules {
  id: string;
  customerName: string;
  customerId?: boolean;
  routeName: any;
  routeId: any;
  scheduledDate: string;
  createdAt: string;
  updatedAt: string;
  beatPlanId: string;
  upload_status: any;
  toBeProcessed: boolean;
  mdmerror?: BulkImportDataMdmerror;
  scheduleStatus?: string;
}

interface CampaignCustomer {
  id: string;
  campaignMasterId: string;
  customerName: string;
  mobileNumber: string;
  customerCode: string;
  customerId: string;
  parameters: Record<string, string>;
  toBeProcessed: boolean;
  upload_status: string;
  mapping_status: string;
  createdAt: string;
  updatedAt: string;
  mdmerror: string | null;
}

export interface BulkImportDataRecord {
  id: string;
  name: string;
  description: string;
  parentSku: string;
  companyCode: string;
  CompanyName: string;
  productVariants: string;
  customFields: string;
  divisionCFACodes: string;
  collections: string;
  campaignCustomers: CampaignCustomer[];
  campaignCode: string;
  campaignId: string;
  entityObj: unknown | null;
  // entityObj: string;
  createdAt: string;
  updatedAt: string;
  uploadBatchId: string;
  uploadBatchAttemptsId: string;
  messageId?: string;
  isMsgConsumed?: boolean;
  productVariants_facets: string;
  productVariants_name: string;
  productVariants_sku: string;
  productVariants_listPrice: number;
  productVariants_shortName: string;
  productVariants_shortDescription: string;
  productVariants_sortOrder: number;
  productVariants_taxCategoryCode: string;
  productVariants_erpId: string;
  productVariants_erpUOM: string;
  productVariants_ean: string;
  productVariants_enabled: any;
  productVariants_vairantCode: any;
  productVariants_upcCode: string;
  productVariants_hsnCode: string;
  productVariants_baseUom: string;
  productVariants_packSize: number;
  productVariants_minOrderQty: number;
  productVariants_maxOrderQty: number;
  productVariants_qtyMultiplier: number;
  productVariants_grossWeight: number;
  productVariants_netWeight: number;
  productVariants_weightUOM: any;
  productVariants_volume: number;
  productVariants_volumeUOM: any;
  productVariants_erpPriceUOM: string;
  productVariants_warrentyInformation: string;
  productVariants_condition: string;
  productVariants_MRP: number;
  productVariants_PTR: string;
  productVariants_caseSize: any;
  productVariants_isSpecial: any;
  productVariants_packingInfo: any;
  productVariants_ZINS: number;
  productVariants_mfgName: any;
  productVariants_mfgCode: any;
  productVariants_minRemShelfLife: number;
  productVariants_totShelfLife: any;
  mdmerror?: BulkImportDataMdmerror;
  toBeProcessed: boolean;
  customerDetails_companyName: string;
  distributorCode: string;
  customerDetails_distributorCode: string;
  phone: string;
  phone2: string;
  customerDetails_gstin: string;
  customerDetails_name: string;
  mapping_status: BulkRecordMappingStatus;
  original_mapping_status: BulkRecordMappingStatus;
  // original_mapping_criteria: string;

  isActive: boolean;
  customerDetails: any;
  customerGroupCodes: any;
  status: any;
  cfa: any;
  upload_status: string;
  mapping_criteria: { criteria: string };
  mapping_suggested: ERPMappingSuggested[] | null;
  mapping_selected: string;
  customerDetails_telephone: any;
  customerDetails_email: any;
  customerDetails_CSTNumber: any;
  customerDetails_dlNumber: any;
  customerDetails_dlExpiry: any;
  customerDetails_distributorChannel: any;
  customerDetails_grossCreditLimit: any;
  customerDetails_creditLimitPeriod: any;
  customerDetails_shippingAddress_shippingAddress1: any;
  customerDetails_shippingAddress_shippingAddress2: any;

  customerDetails_physicalAddress_address1: any;
  customerDetails_physicalAddress_address2: any;
  customerDetails_postalCode: any;
  customerDetails_stateCode: any;
  customerDetails_countryCode: string;
  customerDetails_cityName: any;
  customerDetails_creditLimitDetails: any;

  referenceInvoiceNumber: string;
  refOrderNumber: any;
  docNumber: string;
  narration: any;
  invoiceStatus: any;
  cfaCode: string;
  discountRate: any;
  paymentTerms: any;
  invoiceDate: string;
  dueDate: any;
  invoiceAmount: number;
  invoiceAmountBase: any;
  invoiceAmountWithAdjustment: any;
  disc: any;
  cgst: any;
  sgst: any;
  igst: any;
  cess: any;
  irn: any;
  irnStatus: any;
  lrDate: any;
  lrNumber: any;
  destination: any;
  numCases: any;
  TDSRate: any;
  TDSAmount: any;
  TCSRate: any;
  TCSAmount: any;
  transporterName: any;
  calculationMethod: any;
  discountAmount: any;
  ptrDiscAmt: any;
  spclDiscAmtPts: any;
  utgst: any;
  educationCess: any;
  debitNoteNumber: any;
  debitNoteAmt: any;
  creditNoteOneNumber: any;
  creditNoteOneAmtPts: any;
  creditNoteTwoNumber: any;
  creditNoteTwoAmtPts: any;
  creditNoteThreeNumber: any;
  creditNoteThreeAmtPts: any;
  roundOff: any;
  PONumber: any;
  orderDate: any;
  divisionCode: any;
  itemList: any;
  customerName: string;

  customerCode: any;
  transactionType: string;
  transactionAmount: string;
  transactionDate: string;
  transactionReferenceCode: string;

  erpOrderNumber: string;
  customerFirmName: string;
  clearingDocNumber: any;
  docNumberAmountClearedList: string;
  invoiceReferenceNumber: any;
  clearingDate: any;
  chequeReferenceNumber: any;

  referenceTransactionNumber: string;
  instrumentNumber: any;
  bankReference: any;
  bankName: any;
  paymentMode: any;

  code: any;
  isArchived: boolean;
  priceListItems: string;
  priceConditions: string;
  // priceListItems: {
  //   skuCode: string;
  //   pts: string;
  // }[];
  // priceConditions: {
  //   customerIds: string[];
  // };
  criteria: string;
  type: string;
  startDate: any;
  endDate: any;

  customers: {
    customerId: string;
    customerName: string;
  }[];
  priceListCode: string;
  tag?: string;
  totalOrderValue?: number;
  order_date?: string;
  supplierName?: string;
  fulfillmentLocationCode?: string;
  email?: string;
  cityName?: string;
  postalCode?: string;
  beatPlanSchedules?: BeatPlanSchedules[];
  teamMemberName?: string;
  teamMemberId?: string;
  beatType?: string;
  headDivisionCode?: string;
  fromDate?: string;
  toDate?: string;
  openingBalance?: number;
  closingBalance?: number;

  customerId?: string;
  orderItems?: {
    id: string;
    productSku?: string;
    productVariantId: number;
    quantity: number;
    unitPrice?: string;
    discount?: string;
    discountType?: 'direct' | 'percent';
    productName?: string;
    operator?: string;
    orderInboundId: string;
    erpOrderNumber?: string;
    mapping_status: any;
    mapping_criteria: any;
    mapping_suggested: any;
    mapping_selected: any;
    toBeProcessed: number;
    upload_status: string;
    mdmerror: any;
  }[];
  dispatchDate?: string;
  dispatchDocNumber?: string;

  skuCount?: number;
}

export interface ERPMappingSuggested {
  name?: string;
  gstin?: string;
  phone?: string;
  firmName?: string;
  inviteId?: string;
  distributorCode?: string;

  productVariantId?: number;
  sku?: string;
  buyingPrice?: number;
  sellingPrice?: number;

  packSize?: number;
  productId?: number;

  docNumber?: string;
  customerName?: string;

  transactionAmount?: string;
  transactionType?: string;
  customerFirmName?: string;

  customer_name?: string;
  transactionReferenceCode?: string;
  transaction_Amount?: number;
}

export interface BulkImportDataMdmerror {
  id: number;
  entity: string;
  entityCode: string;
  message: string;
  createdAt: string;
}

export interface BulkImportListRequest {
  companyCode: string;
  pageNo: number;
  pageSize: number;
  body?: {
    entity?: string;
    includeCustomerCount?: boolean;
  };
}

export interface BulkImportListResponse {
  records: BulkImport[];
  endRecord: number;
  startRecord: number;
  totalRecords: number;
}

export interface BulkImport {
  id: string;
  createdAt: string;
  totalRecords: number;
  processedRecords: number;
  notProcessedRecords: string;
  failedRecords: number;
  successfulRecords: number;
  status: BulkImportStatus;
  entity: BulkImportEntityType;
  companyCode: string;
  fileName: string;
}

export enum BulkImportStatus {
  PROCESSING = 'PROCESSING',
  FAILED = 'FAILED',
  SUCCESSFUL = 'SUCCESSFUL',
  EXTRACTED = 'EXTRACTED',
  TRANSFORMED = 'TRANSFORMED',
  ANALYSED = 'ANALYSED',
  SKIPPED = 'SKIPPED',
  CONFIRMED = 'CONFIRMED',
  SENT_TO_QUEUE = 'SENT_TO_QUEUE',
  COMPLETED = 'COMPLETED',
}

export enum BulkImportEntityType {
  DIVISION_MASTER = 'DIVISION_MASTER',
  HEAD_DIVISION_MASTER = 'HEAD_DIVISION_MASTER',
  CFA_MASTER = 'CFA_MASTER',
  PRODUCT_MASTER = 'PRODUCT_MASTER',
  CUSTOMER_MASTER = 'CUSTOMER_MASTER',
  LEDGER_DETAILS = 'LEDGER_DETAILS',
}

export interface ErpFileUploadResponse {
  id: string;
  syncType: string;
  erpSystemId: string;
  companyCode: string;
  workspaceId: string;
  filePath: string;
  fileName: any;
  createdAt: string;
  updatedAt: string;
  mastersWithNoColumnMapping: string[];
  columnMappingDetails: ColumnMappingDetails;
}

export interface ErpFileUploadRequest {
  workspaceId: string;
  params: {
    syncType: string;
    erpSystemCode: 'CUSTOM' | 'TALLY';
    companyCode: string;
    isBulkUpload?: boolean;
  };
  body: FormData;
}

export interface ListErpUploadsRequest {
  workspaceId: string;
  params: {
    pageSize: number;
    pageNo: number;
  };
  body?: {
    entity?: string;
    includeCustomerCount?: true;
  };
}

export interface ListErpUploadsResponse {
  dateFilter: string[];
  startRecord: number;
  endRecord: number;
  totalRecords: number;
  records: ListErpUploadsResponseRecord[];
}

export interface ListErpUploadsResponseRecord {
  id: string;
  fileName: string;
  sync_type: string;
  createdAt: string;
  totalRecords: string;
  processedRecords: string;
  notProcessedRecords: string;
  successfulRecords: string;
  failedRecords: string;
  status: ListErpUploadsStatus;
  columnMappingDetails: ColumnMappingDetails;
  erpSystemCode: string;
  customerCount?: number;

  filePath: string;
  uploadBatches: ListErpUploadsResponseUploadBatch[];
}

export interface ListErpUploadsResponseUploadBatch {
  id: string;
  totalRecords: number;
  processedRecords: number;
  notProcessedRecords: number;
  failedRecords: number;
  successfulRecords: number;
  status: string;
  entity: string;
  toBeProcessed: number;
  msgsAheadInQueue: number;
}

export interface ColumnMappingDetails {
  mastersWithColumnMapping: any[];
  mastersWithNoColumnMapping: string[];
}

export enum ListErpUploadsStatus {
  PREPARING = 'PREPARING',
  READY_TO_PROCESS = 'READY_TO_PROCESS',
  CONFIRMED = 'CONFIRMED',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  COLUMN_MAPPING_FOUND = 'COLUMN_MAPPING_FOUND',
  COLUMN_MAPPING_NOT_FOUND = 'COLUMN_MAPPING_NOT_FOUND',
  FAILED = 'FAILED',
  EMPTY = '',
  EXTRACTED = 'EXTRACTED',
  TRANSFORMED = 'TRANSFORMED',
  ANALYSED = 'ANALYSED',
  NO_DATA_FOUND = 'NO_DATA_FOUND',
  WAITING = 'WAITING',
}

export interface ErpUploadBatchDetailsRequest {
  erpBatchId: string;
  params: {
    pageSize: number;
    pageNo: number;
  };
}

export interface ErpUploadBatchDetailsResponse {
  pageSize: number;
  pageNo: number;
  records: ErpUploadBatchDetailsResponseRecord[];
}

export interface ErpUploadBatchDetailsResponseRecord {
  id: string;
  createdAt: string;
  updatedAt: string;
  totalRecords: number;
  processedRecords: number;
  failedRecords: number;
  successfulRecords: number;
  status: string;
  entity: string;
  // entityObj: ErpUploadBatchDetailsEntityObj;
  companyCode: string;
  workspaceId: string;
  reprocessCount: number;
  fileName: string;
  erpSyncBatchId: string;
}

export interface ErpUploadBatchDetailsEntityObj {
  entity: string;
  records: ErpUploadBatchDetailsRecord[];
  fileName: string;
  companyCode: string;
  workspaceId: string;
}

export interface ErpUploadBatchDetailsRecord {
  ledgerDetails?: ErpUploadBatchDetailsLedgerDetail[];
  cfa?: ErpUploadBatchDetailsCfa[];
  phone?: string;
  phone2?: string;
  isActive?: boolean;
  companyCode?: string;
  customerDetails?: ErpUploadBatchDetailsCustomerDetails;
  creditLimitDetails?: any[];
}

export interface ErpUploadBatchDetailsLedgerDetail {
  cfaCode: string;
  dueDate: string;
  division: string;
  docNumber: string;
  narration: string;
  clearingDate: string;
  customerCode: string;
  divisionCode: string;
  erpOrderNumber: string;
  transactionDate: string;
  transactionType: string;
  customerFirmName: string;
  clearingDocNumber: string;
  transactionAmount: string;
  chequeReferenceNumber: string;
  invoiceReferenceNumber: string;
  transactionReferenceCode: string;
  docNumberAmountClearedList: any[];
}

export interface ErpUploadBatchDetailsCfa {
  cfaCode: string;
  salesOrg: string;
  divisionCodes: ErpUploadBatchDetailsDivisionCode[];
}

export interface ErpUploadBatchDetailsDivisionCode {
  code: string;
  isActive: boolean;
}

export interface ErpUploadBatchDetailsCustomerDetails {
  name: string;
  email: string;
  gstin: string;
  cityName: string;
  dlExpiry: string;
  dlNumber: string;
  CSTNumber: string;
  stateCode: string;
  telephone: string;
  postalCode: string;
  companyName: string;
  countryCode: string;
  distributorCode: string;
  physicalAddress: ErpUploadBatchDetailsPhysicalAddress;
  shippingAddress: ErpUploadBatchDetailsShippingAddress;
  grossCreditLimit: number;
  creditLimitPeriod: number;
}

export interface ErpUploadBatchDetailsPhysicalAddress {
  address1: string;
  address2: string;
}

export interface ErpUploadBatchDetailsShippingAddress {
  city: string;
  state: string;
  pincode: string;
  countryCode: string;
  shippingAddress1: string;
  shippingAddress2: string;
}

export type BulkRecordMappingStatus =
  | 'MANUALLY_MAPPED'
  | 'EXISTING'
  | 'MAPPING_FOUND'
  | 'MAPPED_PARTIALLY'
  | 'MAPPING_NOT_FOUND'
  | 'NEW';

export enum BulkRecordMappingStatusEnum {
  EXISTING = 'EXISTING',
  MAPPED_PARTIALLY = 'MAPPED_PARTIALLY',
  MAPPING_FOUND = 'MAPPING_FOUND',
  MAPPING_NOT_FOUND = 'MAPPING_NOT_FOUND',
  MANUALLY_MAPPED = 'MANUALLY_MAPPED',
  NEW = 'NEW',
}
export const BulkRecordMappingStatusTextEnum: Record<
  BulkRecordMappingStatus,
  string
> = {
  EXISTING: 'Existing',
  MAPPED_PARTIALLY: 'Partial Data Found',
  MAPPING_FOUND: 'Similar Data Found',
  MAPPING_NOT_FOUND: 'Data Not Found',
  MANUALLY_MAPPED: 'Manually Mapped',
  NEW: 'New',
};

export interface ERPUploadBatchUpdateRequest {
  uploadBatchId: string;
  body: {
    id: string;
    phone?: string;
    distributorCode?: string;
    customerDetails_companyName?: string;

    parentSku?: string;

    transactionReferenceCode?: string;

    mapping_status?: any;
    mapping_criteria?: any;
    mapping_selected?: any;
    toBeProcessed: boolean;
    beatPlanSchedules?: Partial<BeatPlanSchedules>[];
  }[];
  params: {
    isConfirmed: boolean;
  };
}

export interface ERPUploadBatchUpdateResponse {
  message: string;
  records: BulkImportDataRecord[];
}

export interface DownloadErpFileRequest {
  id: string;
  params: {
    sellerWorkspaceId: string;
    sendSSE: boolean;
  };
}

export interface DownloadErpFileResponse {
  sellerWorkspaceId: string;
  signedUrl: {
    signedURL: string;
  };
}

export interface CustomerMasterColumnsForMapping {
  inviteId?: string;
  phone?: string;
  phone2?: string;
  companyCode?: string;
  isActive?: string;
  status?: string;
  customerGroupCodes?: string;
  telephone?: string;
  email?: string;
  CSTNumber?: string;
  gstin?: string;
  dlNumber?: string;
  dlExpiry?: string;
  distributorChannel?: string;
  grossCreditLimit?: string;
  creditLimitPeriod?: string;
  shippingAddress1?: string;
  shippingAddress2?: string;
  distributorCode?: string;
  name?: string;
  companyName?: string;
  address1?: string;
  address2?: string;
  postalCode?: string;
  stateCode?: string;
  countryCode?: string;
  cityName?: string;
}

export interface ProductMasterColumnsForMapping {
  name?: string;
  description?: string;
  parentSku?: string;
  sku?: string;
  listPrice?: string;
  price?: string;
  shortName?: string;
  shortDescription?: string;
  sortOrder?: string;
  taxCategoryCode?: string;
  erpId?: string;
  erpUOM?: string;
  ean?: string;
  enabled?: string;
  vairantCode?: string;
  upcCode?: string;
  hsnCode?: string;
  baseUom?: string;
  packSize?: string;
  minOrderQty?: string;
  maxOrderQty?: string;
  salesOrg?: string;
  qtyMultiplier?: string;
  grossWeight?: string;
  netWeight?: string;
  weightUOM?: string;
  volume?: string;
  volumeUOM?: string;
  erpPriceUOM?: string;
  warrentyInformation?: string;
  condition?: string;
  MRP?: string;
  PTR?: string;
  caseSize?: string;
  isSpecial?: string;
  packingInfo?: string;
  ZINS?: string;
  mfgName?: string;
  mfgCode?: string;
  minRemShelfLife?: string;
  totShelfLife?: string;
}

export interface InvoiceMasterColumnsForMapping {
  docNumber?: string;
  referenceInvoiceNumber?: string;
  narration?: string;
  invoiceStatus?: string;
  refOrderNumber?: string;
  distributorCode?: string;
  customerName?: string;
  cfaCode?: string;
  discountRate?: string;
  paymentTerms?: string;
  invoiceDate?: string;
  dueDate?: string;
  invoiceAmount?: string;
  invoiceAmountBase?: string;
  invoiceAmountWithAdjustment?: string;
  disc?: string;
  cgst?: string;
  sgst?: string;
  igst?: string;
  cess?: string;
  irn?: string;
  irnStatus?: string;
  status?: string;
  lrDate?: string;
  destination?: string;
  numCases?: string;
  transporterName?: string;
  calculationMethod?: string;
  discountAmount?: string;
  spclDiscAmtPts?: string;
  utgst?: string;
  educationCess?: string;
  debitNoteNumber?: string;
  debitNoteAmt?: string;
  creditNoteOneNumber?: string;
  creditNoteOneAmtPts?: string;
  creditNoteTwoNumber?: string;
  creditNoteTwoAmtPts?: string;
  creditNoteThreeNumber?: string;
  creditNoteThreeAmtPts?: string;
  roundOff?: string;
  PONumber?: string;
  orderDate?: string;
  divisionCode?: string;
  dispatchDocNumber?: string;
  destinationAddress?: string;
  vehicleNumber?: string;
  driverName?: string;
  lrNumber?: string;
  dispatchDate?: string;
  sku?: string;
  erpOrderNumber?: string;
  Qty?: string;
  Unit?: string;
  UnitPrice?: string;
  lineTotal?: string;
  lineTotalWithTax?: string;
  lineDiscount?: string;
  AssAmt?: string;
  GstRt?: string;
  CgstAmt?: string;
  IgstAmt?: string;
  SgstAmt?: string;
  batchNo?: string;
  expiryDate?: string;
  packsizes?: string;
  headDivisionNumber?: string;
  TDSRate?: string;
  TCSRate?: string;
  TDSAmount?: string;
  TCSAmount?: string;
  UTGSTRate?: string;
  UTGSTAmount?: string;
  discountPercent?: string;
  MRP?: string;
  PTR?: string;
  productTitle?: string;
  igstRate?: string;
  hsnCode?: string;
  freeQuantity?: string;
  ptrDiscPerc?: string;
  ptrDiscAmt?: string;
  specialDiscPercOnPts?: string;
  specialDiscAmtOnPts?: string;
  uniformProductCode?: string;
  manufacturerName?: string;
  isVersionTwo?: string;
}

export interface LedgerMasterColumnsForMapping {
  distributorCode?: string;
  transactionType?: string;
  transactionAmount?: string;
  transactionDate?: string;
  transactionReferenceCode?: string;
  referenceTransactionNumber?: string;
  narration?: string;
  docNumber?: string;
  amountCleared?: string;
  dueDate?: string;
  erpOrderNumber?: string;
  divisionCode?: string;
  status?: string;
  cfaCode?: string;
  clearingDocNum?: string;
  invoiceRefNum?: string;
  clearingDate?: string;
  chequeRefNum?: string;
  firmName?: string;
  instrumentNumber?: string;
  bankReference?: string;
  bankName?: string;
  paymentMode?: string;
  fieldMapping: Record<string, Record<string, string>>;
}

export interface GetErpColumnMappingRequest {
  params: {
    erpSyncBatchId?: string;
    workspaceId: string;
    master: string;
    beatPlanType?: string;
    headerRowNumber?: number;
    type: BoundType;
    /** When set to 'json', returns column mapping in JSON format for webhook field mapping. */
    mappingType?: 'json';
  };
}

export interface GetErpColumnMappingResponse {
  id: string;
  createdAt: string;
  updatedAt: string;
  companyCode: string;
  workspaceId: string;
  master: string;
  erpSystemId: string;
  masterColumnNames: Record<string, string>;
  columnMapping:
    | CustomerMasterColumnsForMapping
    | ProductMasterColumnsForMapping
    | InvoiceMasterColumnsForMapping
    | LedgerMasterColumnsForMapping;
  isMapped: boolean;
  mappedFields: MappedFields;
  notMappedFields: NotMappedFields;
  mandatoryColumns: MandatoryColumns;
  mandatoryFields: MandatoryFields;
  fileColumnNames: string[];
  fileData: any[];
  headerRowNumber?: number;
  orderNotes: Record<any, string>;
  fieldMappings: Record<string, Record<string, string>>;
}

export interface MappedFields {
  mappedFields: string[];
}

export interface NotMappedFields {
  notMappedFields: string[];
}

export interface MandatoryColumns {
  mandatoryColumns: string[];
}
export interface MandatoryFields {
  mandatoryFields: Record<string, string[]>;
}

export interface UpdateColumnMappingRequest {
  body: {
    columnMapping:
      | CustomerMasterColumnsForMapping
      | ProductMasterColumnsForMapping
      | InvoiceMasterColumnsForMapping
      | LedgerMasterColumnsForMapping;
    companyCode: string;
    notMappedFields?: string[];
    customAttributes?: Record<any, string>;
    orderNotes?: Record<any, string>;
    headerRowNumber?: number;
    fieldMapping?: Record<string, Record<string, string>>;
  };
  params: {
    erpSyncBatchId?: string;
    workspaceId: string;
    master: string;
    tempColumnMapping?: boolean;
    type: 'export' | 'import';
    /** When set to 'json', saves column mapping in JSON format (webhook field mapping). */
    mappingType?: 'json';
  };
}

export const codeToMaster = {
  Product: 'PRODUCT_MASTER',
  Customer: 'CUSTOMER_MASTER',
  Invoice: 'INVOICE_INBOUND',
  Ledger: 'LEDGER_DETAILS',
  PriceList: 'PRICE_LIST',
  Cart: 'CART_INBOUND',
  Order: 'ORDER_INBOUND',
  Cfa: 'CFA_MASTER',
  BeatPlan: 'BEATPLAN_MASTER',
  Division: 'DIVISION_MASTER',
  TrialBalance: 'TRIALBALANCE_MASTER',
  Dispatch: 'DISPATCH_INBOUND',
};

export const mastersToCode = {
  PRODUCT_MASTER: 'Product',
  CUSTOMER_MASTER: 'Customer',
  INVOICE_INBOUND: 'Invoice',
  CAMPAIGN_MASTER: 'Google Sheet (Campaign)',
  LEDGER_DETAILS: 'Ledger',
  PRICE_LIST: 'PriceList',
  CFA_MASTER: 'Cfa',
  BEATPLAN_MASTER: 'BeatPlan',
  DIVISION_MASTER: 'Division',
  TRIALBALANCE_MASTER: 'TrialBalance',
  CART_INBOUND: 'Cart',
  ORDER_INBOUND: 'Order',
  DISPATCH_INBOUND: 'Dispatch',
};

export interface ListData {
  id: number;
  masterColumn: string;
  masterColumnLabel: string;
  selectedFileColumn: {
    label: string;
    value: string;
  };
  type: string;
  required: boolean;
  error: boolean;
  columnDbName?: string;
}
export interface FieldMappingsData {
  [id: string]: {
    label: string;
    value: string;
    masterKey: string;
    error: boolean;
    required: boolean;
  }[];
}
export interface UpdateErpSyncSettingsResponse {
  id: string;
  createdAt: string;
  updatedAt: string;
  erpSystemId: string;
  companyCode: string;
  workspaceId: string;
  erpSystemCode: string;
  settingsValue: {
    syncType: string;
    frequency: string;
    host: string;
    port: number;
    filesPath: string;
  };
  priceLevel: string;
}

export interface UpdateErpSyncSettingsRequest {
  params: {
    sellerWorkspaceId: string;
    erpSystemCode: string;
  };
  body: {
    settings?: {
      syncType: string;
      frequency: string;
      host: string;
      port: number;
      filesPath: string;
    };
    includeAllPriceLevels?: boolean;
    priceLevel?: string;
    includeProductCategories?: boolean;
    excludedProductCategories?: string;
    orderStatus?: {
      Approved: boolean;
      SubmittedByCustomer: boolean;
    };
    exportConfig: {
      orders: {
        enabled: boolean;
        voucherType?: string;
        voucherTypes?: string[];
      };
      dispatch: {
        enabled: boolean;
        voucherType?: string;
        voucherTypes?: string[];
      };
    };
    customerGroupsMapping: string;
    baseHierarchyPath: string;
  };
}

export interface GetErpSyncSettingResponse {
  id: string;
  createdAt: string;
  updatedAt: string;
  erpSystemId: string;
  companyCode: string;
  workspaceId: string;
  settingsValue: {
    host: string;
    port: number;
    syncType: string;
    filesPath: string;
    frequency: string;
  };
  orderStatus: {
    Approved: boolean;
    SubmittedByCustomer: boolean;
  };
  exportConfig: {
    orders: {
      enabled: boolean;
      voucherType?: string;
      voucherTypes?: string[];
    };
    dispatch: {
      enabled: boolean;
      voucherType?: string;
      voucherTypes?: string[];
    };
  };
  customerGroupsMapping: CustomerGroupType;
  baseHierarchyPath: string;
  priceLevel: string;
  erpSystemCode: string;
  excludedProductCategories: string;
  includeProductCategories: boolean;
  includeAllPriceLevels?: boolean;
}

export enum AppListCodes {
  ZOHO = 'ZOHO',
  CUSTOM = 'CUSTOM',
  ERPNEXT = 'ERPNEXT',
  ZOSYNC = 'ZOSYNC',
  TALLY = 'TALLY',
  SECURESMS = 'SECURESMS',
  INFOBIP = 'INFOBIP',
  SHOPIFY = 'SHOPIFY',
  ODOO = 'ODOO',
  RAZORPAY = 'RAZORPAY',
  GOOGLESHEETS = 'GOOGLESHEETS',
  ZOTOKAPIS = 'ZOTOKAPIS',
  SAP = 'SAP',
}

export enum BoundType {
  Export = 'export',
  Import = 'import',
}

export interface GetAppsListResponse {
  apps: AppTabList[];
  invoiceUploaded?: boolean;
  lastUpdatedAt?: string;
}

export interface AppTabList {
  id: string;
  subscriptionId?: string;
  name: string;
  code: string;
  subtitle: string;
  logo: string;
  description: string;
  landingPage: any;
  attributes?: {
    pricing: string;
    version: string;
    category: string;
    download: Array<{
      link: string;
      version: string;
    }>;
    published_date: string;
    deployment_type: string;
    compatible_editions: string;
    for_support_request: string;
  };
  isPlatform: boolean;
  erpSystemStatus: string;
  erpSystemSubscriptionStatus: string;
  createdBy?: string;
  isSubscribed: boolean;
}

export interface UninstallAppResponse {
  id: string;
  subscriptionId: string;
  name: string;
  code: string;
  subtitle: string;
  logo: string;
  description: string;
  landingPage: any;
  attributes: any;
  isPlatform: boolean;
  erpSystemStatus: string;
  erpSystemSubscriptionStatus: string;
  createdBy: string;
  isSubscribed: boolean;
}

export interface InstallAppResponse {
  id: string;
  subscriptionId: string;
  name: string;
  code: string;
  subtitle: string;
  logo: string;
  description: string;
  landingPage: any;
  attributes: any;
  isPlatform: boolean;
  erpSystemStatus: string;
  erpSystemSubscriptionStatus: string;
  createdBy: string;
  isSubscribed: boolean;
}

export interface GetCredentialsResponse {
  records: {
    id: string;
    createdAt: string;
    updatedAt: string;
    clientId: string;
    clientSecret: string;
    userId: string;
    label: string;
    teamMember?: {
      employeeName: string;
      employeeCode: string;
    };
    attributes?: {
      download?: {
        link: string;
        version: string;
      }[];
    };
    isActive: boolean;
  }[];
  totalRecords: number;
  startRecord: number;
  endRecord: number;
}

export interface GenerateCredentialResponse {
  clientId: string;
  clientSecret: string;
  workspaceId: string;
}

export interface ChangeApiKeyStatusResponse {
  statusCode: number;
  timestamp: string;
  path: string;
  message: {
    message: string;
    error: string;
    statusCode: number;
  };
}

export interface DeleteApiKeyResponse {
  statusCode: number;
  timestamp: string;
  path: string;
  message: {
    message: string;
    error: string;
    statusCode: number;
  };
}

export enum MasterEnum {
  'BATCH_MASTER' = 'BATCH_MASTER',
  'CFA_MASTER' = 'CFA_MASTER',
  'CUSTOMER_MASTER' = 'CUSTOMER_MASTER',
  'DIVISION_MASTER' = 'DIVISION_MASTER',
  'HEADER_DIVISION_MASTER' = 'Head HEADER_DIVISION_MASTER',
  'CAMPAIGN_MASTER' = 'CAMPAIGN_MASTER',
  'PRODUCT_MASTER' = 'PRODUCT_MASTER',
  'LEDGER_DETAILS' = 'LEDGER_DETAILS',
  'ORDER_INBOUND' = 'ORDER_INBOUND',
  'RETURN_ORDER_INBOUND' = 'RETURN_ORDER_INBOUND',
  'INVOICE_INBOUND' = 'INVOICE_INBOUND',
  'PRICE_LIST' = 'PRICE_LIST',
  'CART_INBOUND' = 'CART_INBOUND',
  'BEATPLAN_MASTER' = 'BEATPLAN_MASTER',
  'TRIALBALANCE_MASTER' = 'TRIALBALANCE_MASTER',
  'DISPATCH_INBOUND' = 'DISPATCH_INBOUND',
}

export interface UploadPdfTemplateRequest {
  sellerWorkspaceId: string;
  body: FormData;
  params: {
    companyCode: string;
    type: string;
  };
}

export interface GetPdfTemplateResponse {
  workspaceId: string;
  mappings: {
    value: string;
    regex: string;
    coordinates: Coordinates;
    percentages: Percentages;
    page: number;
    fieldName: string;
  }[];
  updatedAt: string;
  fileUrl: string;
  pdfParsingFields: {
    'Customer Name': Array<string>;
    'Invoice Date': Array<string>;
    'Due Date': Array<string>;
    'Invoice Amount': Array<string>;
    'Invoice Number': Array<string>;
  };
  fieldPriority: Record<string, string>;
  fields: string[];
}
export interface GetPdfTemplateRequest {
  sellerWorkspaceId: string;
  type: string;
}
export interface GetPdfCoordinatesRequest {
  sellerWorkspaceId: string;
  body: {
    fieldName: string;
    regex: string;
    isCustomRegex?: boolean;
  };
  category?: string;
  params: {
    type: string;
  };
}
export interface GetPdfCoordinatesResponse {
  matches: {
    value: string;
    regex: string;
    coordinates: Coordinates;
    percentages: Percentages;
    page: number;
  }[];
}

export interface UpdatePdfTemplateMappingRequest {
  workspaceId: string;
  body: {
    fields: {
      fieldName: string;
      page: number;
      value: string;
      coordinates: Coordinates;
      percentages: Percentages;
      regex: string;
    }[];
    fieldPriority: Record<string, string>;
  };
  params: {
    type: string;
  };
}

export interface Coordinates {
  x0: number;
  top: number;
  x1: number;
  bottom: number;
}

export interface Percentages {
  left: number;
  top: number;
  width: number;
  height: number;
}
export interface GetSFTPCredentialsResponse {
  host: string;
  port: number;
  username: string;
}

export interface GetColumnMappingStatusResponse {
  structuredColumnMappingStats: {
    master: MasterEnum;
    totalColumns: number;
    mappedColumns: number;
    unmappedColumns: number;
    isMapped: boolean;
  }[];
  unstructuredColumnMappingStats: {
    master: MasterEnum;
    isMapped: boolean;
    lastUpdatedAt?: string | null;
    type?: string;
  }[];
}

export interface GetErpCompaniesResponse {
  companies: string[];
}

export interface UpdateRazorPayCredentialsRequest {
  sellerWorkspaceId: string;
  config: {
    key_id: string;
    key_secret: string;
  };
}
export interface GetRazorPayCredentialsRequest {
  params: {
    sellerWorkspaceId: string;
  };
}
export interface GetRazorPayCredentialsResponse {
  key_id: string;
  key_secret: string;
}

export enum ErpSystemsAppEnum {
  ZOHO = 'ZOHO',
  ERPNEXT = 'ERPNEXT',
  GOOGLESHEETS = 'GOOGLESHEETS',
  ZOTOKAPIS = 'ZOTOKAPIS',
  THIRD_PARTY = 'THIRD_PARTY',
}

export interface GetZosyncSettingsResponse {
  workspaceId: string;
  syncDate: string;
  syncSettings: Record<string, any>;
  tax_mapping: Record<string, string>;
  version: string;
  lastSyncedAt: string;
  deletionStatus: string;
  taxRates: Array<string>;
}

export interface UpdateZosyncSettingsRequest {
  params: {
    sellerWorkspaceId: string;
  };
  body: {
    tax_mapping: Record<string, string>;
  };
}

export interface GetZoApiWebhookConfigRequest {
  params: {
    entity?: string;
    clientId: string;
  };
  sellerWorkspaceId: string;
}
export type GetZoApiWebhookConfigResponse = {
  id: string;
  createdAt: string;
  updatedAt: string;
  workspaceId: string;
  entity: string;
  webhookUrl: string;
  clientId: string;
  authenticationStrategy: WebhookAuthentication;
  headers: Record<string, string>;
  parameters: Record<string, string>;
  authenticationConfig: AuthenticationConfig;
  samplePayload: Record<string, unknown>;
}[];

export interface AuthenticationConfig {
  url: string;
  method: 'POST' | 'GET';
  headers: Record<string, string>;
  parameters: Record<string, string>;
  body: string;
  tokenResponseExpression: string;
  sourcePayload?: string;
}

export type UpdateZoApiWebhookConfigRequest = {
  workspaceId: string;
  clientId: string;
  entity: string;
  webhookUrl: string;
  headers: Record<string, string>;
  parameters: Record<string, string>;
  authenticationStrategy: WebhookAuthentication;
  isSecured: boolean;
  authenticationConfig: AuthenticationConfig;
};

export type UpdateZoApiWebhookConfigResponse = {
  id: string;
  createdAt: string;
  updatedAt: string;
  workspaceId: string;
  entity: string;
  webhookUrl: string;
  clientId: string;
  headers: Record<string, string>;
  parameters: Record<string, string>;
};

export interface GetErpExportMappingsRequest {
  sellerWorkspaceId: string;
  entity: string;
  voucherType: string;
}

export interface ErpExportMappingResponse {
  id: string;
  workspaceId: string;
  entity: string;
  voucherType: string;
  templateBody: string;
  samplePayload: Record<string, unknown>;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateErpExportMappingsRequest {
  sellerWorkspaceId: string;
  entity: string;
  voucherType: string;
  body: {
    templateBody: string;
  };
}

export interface ErpNextCredentials {
  baseUrl: string;
  apiKey: string;
  apiSecret: string;
  mappedCompany?: string;
}

export interface SaveErpNextCredentialsRequest {
  params: {
    erpSystemCode: 'ERPNEXT';
    sellerWorkspaceId: string;
  };
  body: ErpNextCredentials;
}

export interface SaveErpNextCredentialsResponse {
  baseUrl: string;
  workspaceId: string;
  erpSystemCode: string;
  apiKey: string;
  apiSecret: string;
  mappedCompany: string;
  companies: string[];
}

export interface GetErpNextCredentialsRequest {
  params: {
    erpSystemCode: 'ERPNEXT';
    sellerWorkspaceId: string;
  };
}

export interface SaveFetchDateRequest {
  params: {
    provider: 'ERPNEXT' | 'ZOHO';
    sellerWorkspaceId: string;
    masters: string[];
    startDate?: string;
  };
}

export interface GetErpNextCredentialsResponse {
  baseUrl: string;
  workspaceId: string;
  erpSystemCode: string;
  apiKey: string;
  apiSecret: string;
  mappedCompany: string;
  companies: string[];
  masters: Record<string, string>;
}

export enum WebhookAuthentication {
  NO_AUTH = 'NO_AUTH',
  SIMPLE_AUTH = 'SIMPLE_AUTH',
  TOKEN_BASED_AUTH = 'TOKEN_BASED_AUTH',
}

export interface UpdateERPAuthenticationRequest {
  params: {
    sellerWorkspaceId: string;
  };
  body?: GetERPAuthenticationResponse['config'];
}

export interface GetERPAuthenticationResponse {
  config: Config;
  defaultConfig: DefaultConfig;
  pollingState: {
    enabled: boolean;
    entities: {
      entity: string;
      status: string;
      isActive: boolean;
      pollIntervalSec: number;
      nextPollAt: any;
      lastPolledAt: any;
    }[];
  };
}

interface Config {
  id: string;
  workspaceId: string;
  companyCode: string;
  erpId: string;
  baseUrl: string;
  authenticationStrategy: string;
  authenticationConfig: GetERPAuthenticationAuthenticationConfig;
  apiEndpoints: GetERPAuthenticationApiEndpoints;
  accessToken: string;
  tokenExpiresAt: string;
  isActive?: any;
  createdAt: string;
  updatedAt: string;
}

export interface DefaultConfig {
  baseUrl: string | null;
  authenticationStrategy: string;
  authenticationConfig: DefaultAuthenticationConfig;
  apiEndpoints: GetERPAuthenticationApiEndpoints;
  importableMasters: string[];
}

export interface GetERPAuthenticationAuthenticationConfig {
  url: string;
  method: string;
  headers: Record<string, string>;
  parameters: Record<string, string>;
  body: any;
  tokenResponseExpression: string;
  tokenTtlMinutes: number;
  tokenHeaderTemplate: string;
  tokenHeaderName: string;
}

export interface DefaultAuthenticationConfig {
  url: string;
  method: string;
  headers: Record<string, string>;
  parameters: Record<string, string>;
  body: any;
  tokenResponseExpression: string;
  tokenTtlMinutes: number;
}

export interface Endpoint {
  path: string;
  method: string;
  headers: Record<string, string>;
  parameters: Record<string, string>;
  body: any;
}

export interface GetERPAuthenticationApiEndpoints {
  customer: Endpoint;
  product: Endpoint;
  invoice: Endpoint;
  'price-list': Endpoint;
  cfa: Endpoint;
}

export interface ConnectGoogleRequest {
  workspace_id: string;
  connector_type: string;
}
export interface ConnectGoogleResponse {
  connector_type: string;
  auth_url: string;
}

export interface GetConnectorsRequest {
  workspace_id: string;
  showSuccess?: boolean;
}

export interface GetConnectorsResponse {
  connector_type: string;
  name: string;
  description: string;
  icon_url: null;
  status: string;
  account_email: string;
  connected_at: string;
  sheet_ids: string[];
}

export interface GetGoogleSheetsPickerConfigRequest {
  workspace_id: string;
  connector_type: 'GOOGLE_SHEETS';
}

export interface GetGoogleSheetsPickerConfigResponse {
  connector_type: 'GOOGLE_SHEETS';
  config: {
    app_id: string;
    google_api_key: string;
    oauth_token: string;
  };
}

export interface RegisterGoogleSheetRequest {
  workspace_id: string;
  spreadsheet_id: string;
}

export interface RegisterGoogleSheetResponse {
  spreadsheet_id: string;
  title: string;
  sheets: {
    sheet_id: number;
    title: string;
  }[];
}

export interface DisconnectGoogleSheetsRequest {
  workspace_id: string;
  connector_type: 'GOOGLE_SHEETS';
}

export interface DisconnectGoogleSheetsResponse {
  workspace_id: string;
  connector_type: 'GOOGLE_SHEETS';
  status: 'disconnected';
}

export interface GetGoogleSheetResponse {
  webViewLink: string;
  id: string;
  name: string;
  createdAt: string;
  modifiedAt: string;
}

export interface GetGoogleSheetRequest {
  workspace_id: string;
}

export interface DeleteGoogleRequest {
  spreadsheet_id: string;
  workspace_id: string;
}
